module.exports = __webpack_public_path__ + "img/image05_sp.c2982c8d.jpg";